import { Tchekb } from './../model/tchekb.model';
import { TchekImageChild } from './../model/image';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import 'parse';
import { TchekImage } from '../model/image';
import { ParametersService } from './parameters.service';
import { Subject } from 'rxjs';
import { Tchek } from '../model/tchek';
const parse: typeof Parse = require('parse');
import { fabric } from 'fabric_gesture';
import {environment} from "../../environments/environment";

@Injectable()

export class ImagesService {

  constructor(private readonly _parametersService: ParametersService, private http: HttpClient) {
    this.testApi()
  }

  private reloadImages = new Subject<TchekImage>();
  reloadImagesObs = this.reloadImages.asObservable();
  runReloadImages(image: TchekImage) {
    this.reloadImages.next(image)
  }

  private classificationImages = new Subject<string>();
  classificationImagesObs = this.classificationImages.asObservable();
  nextImageClassification(id: string) {
    this.classificationImages.next(id)
  }


  public async countEndClassificationImages(): Promise<number> {
    const query = new parse.Query('Images')
    query.limit(10000000000000)
    query.doesNotExist('parentPtr')
    query.doesNotExist('detectionModel')
    query.equalTo('classification', true)
    try {
      let count = await query.count()
      return count
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public imageList: TchekImage[]
  skip = 0
  limit = 50
  step = 50
  public async getClassificationImages(reload = false): Promise<TchekImage[]> {
    if (this.imageList && this.imageList.length > 0 && reload === false)
      return this.imageList
    else {
      const altoQuery = new parse.Query('AltoAPI')
      altoQuery.include('APITokenPtr')
      altoQuery.equalTo('APITokenPtr', {
        __type: 'Pointer',
        className: 'APIToken',
        objectId: '6hr4QnbVjx'
      })

      const query = new parse.Query('Images')
      query.descending('createdAt')
      query.doesNotExist('parentPtr')
      query.doesNotExist('detectionModel')
      query.notEqualTo('classification', true)
      query.include('tchekPtr')
      query.include('altoPtr')

      const FinalQuery = parse.Query.and(query,
        parse.Query.or(
          new parse.Query('Images').matchesQuery('altoPtr', altoQuery),
          new parse.Query('Images').doesNotExist('altoPtr'),
        )
      );
      FinalQuery.skip(this.skip)
      FinalQuery.limit(this.limit)

      const queryT = new parse.Query('Tchek')
      queryT.equalTo('objectId', 'VATtjUkm1t')

      try {
        let tchekFakePtr = await queryT.first()
        let tchek = new Tchekb(tchekFakePtr)
        let list = await FinalQuery.find()
        console.log('list images', list);
        let ArrayImages: TchekImage[] = list.map<TchekImage>(o => new TchekImage(o))
        ArrayImages.forEach(i => {
          if (i.tchekPtr === undefined) {
            i.tchekPtr = tchek
            console.log('undefined');
          }
        })
        if (reload === false)
          this.skip += this.step;
        this.imageList = ArrayImages
        return this.imageList
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public cloudfrontUrl(fileName: string, resize: { width: number; height: number; fit: string }
    = { width: 500, height: 500, fit: 'outside' }): string {
     const config = {
      bucket: 'tchekprod',
      key: fileName,
      edits: {
        resize
      }
    };
    return 'https://d26lcg3q8zuw55.cloudfront.net/' + btoa(JSON.stringify(config));
  }


  public async getByTchek(tchekId: string): Promise<{ model: string, images: TchekImage[] }[]> {
    const query = new parse.Query('Images')
    if (this._parametersService.isSuperAdmin !== true)
      query.notEqualTo('isDeleted', true)
    query.limit(1000)
      .include(['tchekPtr', 'damagePtr', 'parentPtr'])
    try {
      let result = await query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      }).find()
      let ArrayImages: TchekImage[] = result.map<TchekImage>(o => new TchekImage(o))
      ArrayImages = ArrayImages.sort((a, b) => {
        let r1 = a.parentPtr ? a.parentPtr.id : a.id
        let r2 = b.parentPtr ? b.parentPtr.id : b.id
        if (r1 < r2) { return -1; }
        if (r1 > r2) { return 1; }
        return 0;
      })
      let ArrayResult: { model: string, images: TchekImage[] }[] = []
      // Stock original images : 
      ArrayResult.push({ model: 'Original', images: ArrayImages.filter(image => image.parentPtr === undefined) })
      ArrayImages = ArrayImages.filter(image => image.parentPtr !== undefined)
      // Stock other images detection :
      ArrayImages.forEach(image => {
        let index = ArrayResult.findIndex(a => { return a.model === image.detectionModel })
        if (index === -1)
          ArrayResult.push({
            model: image.detectionModel,
            images: [image]
          })
        else
          ArrayResult[index].images.push(image)
      })
      console.log('image result : ', ArrayResult);
      return ArrayResult
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }


  public async saveImageDetection(file: string): Promise<TchekImage> {
    return new Promise<any | any>((resolve, reject) => {
      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
      acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
      const image = new parse.Object('Images');
      image.setACL(acl);
      image.set('file', new parse.File('image.jpg', { base64: file }))
      image.set('userPtr', parse.User.current())
      image.save().then((value) => {
        resolve(new TchekImage(value))
      }).catch(err => reject(err))
    })
  }

  save = false
  createDamage = false
  apiAddressOnline = environment.backAltoUrl
  apiAddressLocal = 'https://local.alto.tchek.fr:1338'
  public apiToUse = 'online'
  public score = 0.1
  public removeBackground = false
  public blurBackground = false
  public blurFace = false
  public blurLogo = false
  public blurText = false
  public blurLicencePlate = true
  public vin = true
  public mileage = false
  public licencePlate = false
  async runDetectionImage(url: string, b64: string, route: string, tchekId?: string, model?: string, imageId?: string,urlBackground?: string) {
    console.log("sbeURL",urlBackground)
    return new Promise<any | any>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          "X-API-Key": this._parametersService.getAll().api.publicKey
        })
      };
      let api = (this.apiToUse === 'online' ? this.apiAddressOnline : this.apiAddressLocal)
      console.log('api used ', this.apiToUse);
      this.http.post<any>(api + '/apiV1' + route, { url, b64, score: this.score,blurLicencePlate:this.blurLicencePlate,blurText:this.blurText,blurLogo:this.blurLogo,removeBackground:this.removeBackground,blurBackground:this.blurBackground,blurFace:this.blurFace,  tchekId, model, imageId, save: this.save, createDamage: this.createDamage,urlBackground:urlBackground }, httpOptions)
        .subscribe({
          next: data => {
            data.route = route
            resolve(data)
          },
          error: error => {
            console.log(error);
          }
        })
    });
  }

  async testApi() {
    if (this._parametersService.isSuperAdmin !== true) return
    return new Promise<any | any>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          "X-API-Key": this._parametersService.getAll().api.publicKey
        })
      };
      let time = Date.now()
      this.http.post<any>(this.apiAddressLocal + '/apiV1/classification/image', {}, httpOptions)
        .subscribe({
          next: data => {
            let endTime = Date.now()
            if ((endTime - time) < 500)
              this.apiToUse = 'local'
            resolve(data)
          },
          error: error => {
            let endTime = Date.now()
            if (error.status === 501 && (endTime - time) < 500)
              this.apiToUse = 'local'
            console.log(error);
          }
        })
    });
  }

  async runDetectionTchekImage(tchekId: string, modelIa: string) {
    console.log('run detection ');
    return new Promise<any | any>((resolve, reject) => {
      this.runDetectionImage(undefined, undefined, '/detection/tchek', tchekId, modelIa)
        .then((response: any) => {
          console.log('response detection ', response);
          resolve(response);
        }, (error: any) => {
          reject(error);
        });
    });
  }


  compressImage(src: string): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        let canvas = new fabric.Canvas();
        fabric.Image.fromURL(src, img => {

          let newWidth = img.getOriginalSize().width
          let newHeight = img.getOriginalSize().height


          canvas.setHeight(newHeight);
          canvas.setWidth(newWidth);

          img.scaleToWidth(newWidth);
          img.scaleToHeight(newHeight);
          canvas.add(img)
          img.center();

          img.setCoords();

          let result = (canvas.toDataURL({
            format: 'jpeg',
            quality: 0.50
          }) as string).valueOf()
          canvas.setWidth(0);
          canvas.setHeight(0);
          canvas.clear();
          canvas.dispose();
          canvas.removeListeners();
          canvas = null

          resolve(result);

        }, { crossOrigin: 'Anonymous' });
      } catch (error) {
        reject()
      }
    })
  }

  public async saveImages2(file: File, tchekId: string, isInterior: boolean = undefined): Promise<void> {

    let acl = new parse.ACL();
    acl.setPublicReadAccess(false);
    acl.setPublicWriteAccess(false);
    acl.setRoleReadAccess('superAdmin', true);
    acl.setRoleWriteAccess('superAdmin', true);
    acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
    acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
    const image = new parse.Object('Images');


    var myFile
    try {
      if ((file.size / 1000000) > 3) { // update compress image
        let compress = await this.compressImage(window.URL.createObjectURL(file))
        myFile = new parse.File('image.jpeg', { base64: compress });
      } else {
        let type = file.type ? file.type.split('/').pop() : 'jpeg'
        myFile = new parse.File('image.' + type, file);
      }
    } catch (error) {
      let type = file.type ? file.type.split('/').pop() : 'jpeg'
      myFile = new parse.File('image.' + type, file);
    }

    await myFile.save()

    image.setACL(acl);
    image.set('file', myFile)
    image.set('userPtr', parse.User.current())
    image.set('isInterior', isInterior)
    image.set('tchekPtr', {
      __type: 'Pointer',
      className: 'Tchek',
      objectId: tchekId
    })

    let size = await this.getHeightAndWidthFromDataUrl(window.URL.createObjectURL(file))
    console.log(size);
    image.set('size', size)
    console.log('image object', image);
    await image.save();
  }


  getHeightAndWidthFromDataUrl(dataURL): Promise<{
    height: number,
    width: number
  }> {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => {
        resolve({
          height: img.height,
          width: img.width
        })
      }
      img.src = dataURL
    })
  }


  public async saveImages(file: string, tchekId: string, size: { "height": number, "width": number }, damageId?: string): Promise<TchekImage> {
    return new Promise<any | any>((resolve, reject) => {
      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
      acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
      const image = new parse.Object('Images');

      var myFile = new parse.File('image.jpg', { base64: file });
      myFile.save().then(() => {
        image.setACL(acl);
        image.set('file', myFile)
        if (damageId)
          image.set('damagePtr', {
            __type: 'Pointer',
            className: 'Damage',
            objectId: damageId
          })
        image.set('userPtr', parse.User.current())
        image.set('tchekPtr', {
          __type: 'Pointer',
          className: 'Tchek',
          objectId: tchekId
        })
        image.set('size', size)
        console.log('image object', image);
        image.save().then((value) => {
          console.log('value save image', value);
          resolve(value)
        }).catch(err => reject(err))
      });
    })
  }

}


// WEBPACK FOOTER //
// ./src/app/service/images.service.ts